<div class="modal" id="reservationModal" tabindex="-1">
	<div class="modal-dialog modal-dialog-centered">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title">Rezerwacja {{ reservation?.businessCaseNumber }}</h5>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				<table class="table" *ngIf="reservation?.persons">
					<thead>
						<tr>
							<th>Imię</th>
							<th>Nazwisko</th>
							<th>Data urodzenia</th>
							<th>Kontakt</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let pos of reservation?.persons">
							<td>{{ pos.firstName }}</td>
							<td>{{ pos.lastName }}</td>
							<td>{{ pos.birthDate }}</td>
							<td>{{ pos.phone }}, {{ pos.phone2 }}</td>
						</tr>
					</tbody>
				</table>
				<p *ngFor="let commentIstour of reservation?.commentIstour">
					<b *ngIf="commentIstour.data">Komentarz IsTour:</b><br />
					{{ commentIstour.data }}
				</p>
				<div *ngFor="let comment of reservation?.comment">
					<b>Komentarz dla {{ comment.businessCaseNumber }}:</b><br />
					<div class="input-group">
						<textarea class="form-control" name="comment" [(ngModel)]="comment.data"></textarea>
						<button class="btn btn-outline-primary" type="button" (click)="saveComment(comment)">
							Zapisz
						</button>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<div *ngIf="auth.permissionsByCode()[Permissions.RESIDENT_ACCOMMODATION_MANAGEMENT]">
					<div
						*ngIf="!['1', '36'].includes(reservation?.roomType)"
						class="btn btn-primary me-4"
						(click)="changeProductStart()"
					>
						<i class="fas fa-share-square"></i> Zmień produkt
					</div>
					<div
						*ngIf="['1', '36'].includes(reservation?.roomType) && !reservation?.room"
						class="btn btn-primary me-4"
						(click)="moveStartDok()"
					>
						<i class="fas fa-arrow-up"></i> Dokwateruj
					</div>
					<div *ngIf="!reservation?.room" class="btn btn-primary me-4" (click)="moveStart()">
						<i class="fas fa-arrow-up"></i> Kwateruj
					</div>
					<div *ngIf="reservation?.room" class="btn btn-primary me-4" (click)="moveStart()">
						<i class="fas fa-arrow-down"></i> Wykwateruj
					</div>
				</div>
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Zamknij</button>
			</div>
		</div>
	</div>
</div>
